import moment from 'moment';
import { GameDayModel } from '../../models/gameday-model';

export function actualIssuePricingDate(
  deal: GameDayModel.Deal
): Date | undefined {
  let date: moment.Moment;
  if (!deal) {
    return undefined;
  }
  if (deal.orderPeriod && deal.orderPeriod.endDate) {
    date = deal.orderPeriod.endDate;
  } else if (deal.expectedPricingDate) {
    date = deal.expectedPricingDate;
  } else if (deal.saleDate) {
    date = deal.saleDate;
  } else {
    return undefined;
  }

  return date.clone().startOf('day').toDate();
}
